export default __webpack_public_path__ + "static/media/aidan.f0f4aee2.png";